"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlEditButton = void 0;
var logger_1 = require("./logger");
require("./styles.css");
var quill_1 = __importDefault(require("quill"));
var html_parser_1 = require("./html-parser");
var html_formatter_1 = require("./html-formatter");
function $create(elName) {
    return document.createElement(elName);
}
function $setAttr(el, key, value) {
    return el.setAttribute(key, value);
}
var Logger = new logger_1.QuillHtmlLogger();
var htmlEditButton = /** @class */ (function () {
    function htmlEditButton(quill, optionsInput) {
        var options = optionsInput || {};
        var debug = !!(options && options.debug);
        Logger.setDebug(debug);
        Logger.log("logging enabled");
        // Add button to all quill toolbar instances
        var toolbarModule = quill.getModule("toolbar");
        if (!toolbarModule) {
            throw new Error('quill.htmlEditButton requires the "toolbar" module to be included too');
        }
        // this.registerDivModule();
        var toolbarEl = toolbarModule.container;
        var buttonContainer = $create("span");
        $setAttr(buttonContainer, "class", "ql-formats");
        var button = $create("button");
        button.innerHTML = options.buttonHTML || "&lt;&gt;";
        button.title = options.buttonTitle || "Show HTML source";
        button.type = "button";
        var onSave = function (html) {
            quill.clipboard.dangerouslyPasteHTML(html);
        };
        button.onclick = function (e) {
            e.preventDefault();
            launchPopupEditor(quill, options, onSave);
        };
        buttonContainer.appendChild(button);
        toolbarEl === null || toolbarEl === void 0 ? void 0 : toolbarEl.appendChild(buttonContainer);
    }
    return htmlEditButton;
}());
exports.htmlEditButton = htmlEditButton;
function launchPopupEditor(quill, options, saveCallback) {
    var htmlFromEditor = quill.container.querySelector(".ql-editor").innerHTML;
    var popupContainer = $create("div");
    var overlayContainer = $create("div");
    var msg = options.msg ||
        'Edit HTML here, when you click "OK" the quill editor\'s contents will be replaced';
    var cancelText = options.cancelText || "Cancel";
    var okText = options.okText || "Ok";
    var closeOnClickOverlay = options.closeOnClickOverlay !== false;
    $setAttr(overlayContainer, "class", "ql-html-overlayContainer");
    $setAttr(popupContainer, "class", "ql-html-popupContainer");
    var popupTitle = $create("span");
    $setAttr(popupTitle, "class", "ql-html-popupTitle");
    popupTitle.innerText = msg;
    var textContainer = $create("div");
    textContainer.appendChild(popupTitle);
    $setAttr(textContainer, "class", "ql-html-textContainer");
    var codeBlock = $create("pre");
    $setAttr(codeBlock, "data-language", "xml");
    codeBlock.innerText = (0, html_formatter_1.FormatHTMLStringIndentation)(htmlFromEditor, Logger);
    var htmlEditor = $create("div");
    $setAttr(htmlEditor, "class", "ql-html-textArea");
    var buttonCancel = $create("button");
    buttonCancel.innerHTML = cancelText;
    $setAttr(buttonCancel, "class", "ql-html-buttonCancel");
    var buttonOk = $create("button");
    buttonOk.innerHTML = okText;
    $setAttr(buttonOk, "class", "ql-html-buttonOk");
    var buttonGroup = $create("div");
    $setAttr(buttonGroup, "class", "ql-html-buttonGroup");
    var prependSelector = document.querySelector(options.prependSelector);
    buttonGroup.appendChild(buttonCancel);
    buttonGroup.appendChild(buttonOk);
    htmlEditor.appendChild(codeBlock);
    textContainer.appendChild(htmlEditor);
    textContainer.appendChild(buttonGroup);
    popupContainer.appendChild(textContainer);
    overlayContainer.appendChild(popupContainer);
    if (prependSelector) {
        prependSelector.prepend(overlayContainer);
    }
    else {
        document.body.appendChild(overlayContainer);
    }
    var modules = options && options.editorModules;
    var hasModules = !!modules && !!Object.keys(modules).length;
    var modulesSafe = hasModules ? modules : {};
    // console.time('new Quill')
    var editor = new quill_1.default(htmlEditor, {
        modules: __assign({ syntax: options.syntax }, modulesSafe),
    });
    // console.timeEnd('new Quill')
    buttonCancel.onclick = function () {
        if (prependSelector) {
            prependSelector.removeChild(overlayContainer);
        }
        else {
            document.body.removeChild(overlayContainer);
        }
    };
    if (closeOnClickOverlay) {
        overlayContainer.onclick = buttonCancel.onclick;
    }
    popupContainer.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    buttonOk.onclick = function () {
        var container = editor.container;
        var qlElement = container.querySelector(".ql-editor");
        var htmlInputFromPopup = qlElement.innerText;
        var htmlOutputFormatted = (0, html_parser_1.OutputHTMLParser)(htmlInputFromPopup);
        Logger.log("OutputHTMLParser", { htmlInputFromPopup: htmlInputFromPopup, htmlOutputFormatted: htmlOutputFormatted });
        saveCallback(htmlOutputFormatted);
        if (prependSelector) {
            prependSelector.removeChild(overlayContainer);
        }
        else {
            document.body.removeChild(overlayContainer);
        }
    };
}
window["htmlEditButton"] = htmlEditButton;
exports.default = htmlEditButton;
